import { render, staticRenderFns } from "./CarLoaderComponent.vue?vue&type=template&id=0f5eda98"
import script from "./CarLoaderComponent.vue?vue&type=script&lang=ts"
export * from "./CarLoaderComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports